import React, { useState } from 'react';

const WhatItDoes = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        {
            title: 'Automated Data Extraction',
            description: 'Automatically reads a pre-defined set of variables straight from your plant DCS, DA system, or Historian — on demand or as a scheduled task. No manual exports, no disruption to real-time plant operations.',
            imageUrl: '/assets/data/img2.png'
        },
        {
            title: 'Data Health Checkup',
            description: 'Run diagnostic health screenings on raw plant datasets automatically. Identifies missing metrics, instrumentation drops, and out-of-bound variables before processing anomalies occur.',
            imageUrl: '/assets/data/img2.png'
        },
        {
            title: 'Process Analytics',
            description: 'Deep dive into performance indicators with advanced algorithmic computation models. Uncover inefficiencies, correlate historical batches, and isolate driving variables seamlessly.',
            imageUrl: '/assets/data/img2.png'
        },
        {
            title: 'Process Monitoring',
            description: 'Track ongoing live metrics against computed benchmarks dynamically. Receive targeted automated drift alerts to address variations well ahead of threshold breaches.',
            imageUrl: '/assets/data/img2.png'
        },
        {
            title: 'Data Visualization',
            description: 'Render complex structural analytics down into crisp intuitive industrial charts, dashboards, and operational summaries optimized for collaborative plant overviews.',
            imageUrl: '/assets/data/img2.png'
        }
    ];

    return (
        <section className="w-full bg-white pt-16 lg:pt-24 select-none">
            <div className="max-w-[1440px] w-full mx-auto px-6 lg:px-[80px]">

                <h2 className="text-[20px] sm:text-[30px] font-sora font-[600] text-[#01386A] tracking-tight mb-16 text-left">
                    What It Does
                </h2>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-[92px] items-start">

                    <div className="lg:col-span-6 flex flex-col w-full">
                        {items.map((item, index) => {
                            const isActive = activeIndex === index;
                            return (
                                <div
                                    key={index}
                                    onMouseEnter={() => setActiveIndex(index)}
                                    className="group w-full relative pt-6 pb-6 border-b border-gray-100 cursor-pointer overflow-hidden text-left"
                                >
                                    <h3
                                        className={`text-[16px] lg:text-[20px] font-sora font-[600] tracking-tight transition-colors duration-300 ${isActive ? 'text-[#01386A]' : 'text-[#0000008C] group-hover:text-[#01386A]'
                                            }`}
                                    >
                                        {item.title}
                                    </h3>

                                    <div
                                        className={`absolute bottom-0 left-0 h-[2px] w-full bg-orange-500 transition-transform duration-500 ease-out z-20 origin-left ${isActive ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                                            }`}
                                    />
                                    <div
                                        className={`absolute bottom-0 left-0 h-[1px] w-full bg-[#D5D5D5] transition-transform duration-500 ease-out origin-left z-10`}
                                    />
                                </div>
                            );
                        })}
                    </div>

                    {/* Right Content View Column */}
                    <div className="lg:col-span-6 flex flex-col gap-8 text-left min-h-[420px]">
                        <p className="text-[14px] lg:text-[16px] font-graphik font-[500] text-[#49577A] leading-relaxed transition-opacity duration-300">
                            {items[activeIndex].description}
                        </p>

                        <div className="w-full h-[260px] sm:h-[320px] bg-slate-900 overflow-hidden relative shadow-xs">
                            <img
                                src={items[activeIndex].imageUrl}
                                alt={items[activeIndex].title}
                                className="w-full h-full object-cover transition-all duration-500 transform scale-100"
                            />
                        </div>
                    </div>

                </div>

            </div>
        </section>
    );
};

export default WhatItDoes;